import React from 'react';
import './AuthMethodBadge.css';

/* ── How a guest signed in: the Session.authMethod values (backend utils/authMethod) ── */
export const AUTH_METHODS = [
    { value: 'pms',               label: 'PMS Login',           icon: 'fa-hotel',         color: '#7c3aed', bg: '#ede9fe' },
    { value: 'voucher',           label: 'Voucher',             icon: 'fa-ticket-alt',    color: '#0369a1', bg: '#e0f2fe' },
    { value: 'access_code',       label: 'Access Code',         icon: 'fa-key',           color: '#b45309', bg: '#fef3c7' },
    { value: 'username_password', label: 'User & Password',     icon: 'fa-user-lock',     color: '#065f46', bg: '#d1fae5' },
    { value: 'sms_otp',           label: 'SMS OTP',             icon: 'fa-sms',           color: '#1d4ed8', bg: '#dbeafe' },
    { value: 'whatsapp_otp',      label: 'WhatsApp OTP',        icon: 'fa-whatsapp',      color: '#15803d', bg: '#dcfce7' },
    { value: 'email_otp',         label: 'Email OTP',           icon: 'fa-envelope',      color: '#9d174d', bg: '#fce7f3' },
    { value: 'qr',                label: 'QR Login',            icon: 'fa-qrcode',        color: '#374151', bg: '#f3f4f6' },
    { value: 'mac',               label: 'MAC Auth',            icon: 'fa-network-wired', color: '#92400e', bg: '#fef3c7' },
    { value: 'social',            label: 'Social Login',        icon: 'fa-share-alt',     color: '#6d28d9', bg: '#ede9fe' },
    { value: 'resident',          label: 'Resident',            icon: 'fa-house-user',    color: '#0f766e', bg: '#ccfbf1' },
    { value: 'staff',             label: 'Staff',               icon: 'fa-id-badge',      color: '#334155', bg: '#e2e8f0' },
    { value: 'isp',               label: 'ISP Plan',            icon: 'fa-globe',         color: '#1e40af', bg: '#dbeafe' },
    { value: 'otp',               label: 'OTP',                 icon: 'fa-mobile-alt',    color: '#1d4ed8', bg: '#dbeafe' },
    { value: 'custom',            label: 'Custom',              icon: 'fa-code',          color: '#374151', bg: '#f3f4f6' },
];

export const authMeta = (method) =>
    AUTH_METHODS.find(m => m.value === method) ||
    { value: method || 'unknown', label: method || 'Unknown', icon: 'fa-question-circle', color: '#6b7280', bg: '#f3f4f6' };

export default function AuthMethodBadge({ method, small = false }) {
    const m = authMeta(method);
    return (
        <span className={`auth-method-badge${small ? ' auth-badge-sm' : ''}`}
            style={{ background: m.bg, color: m.color }}>
            {/* WhatsApp is a brand icon (fab), the rest solid (fas) */}
            <i className={`${m.icon === 'fa-whatsapp' ? 'fab' : 'fas'} ${m.icon}`}></i>
            {m.label}
        </span>
    );
}
